export const proceduresConstants = {
  GETPROCEDRURES_REQUEST: 'GETPROCEDRURES_REQUEST',
  GETPROCEDRURES_SUCCESS: 'GETPROCEDRURES_SUCCESS',
  GETPROCEDRURES_FAILURE: 'GETPROCEDRURES_FAILURE',
};
